<template>
    <div>
        <div v-if="!pageIndexApiDataIsLoading">
            <company-licence-component/>

            <div class="row">
                <div class="col-md-12 m-b-0">
                    <router-link class="btn btn-white m-r-5" to="/admin"><i class="fa fa-cogs fa-fw fa-lg"></i></router-link>
                    <router-link class="btn btn-white m-r-5 text-orange" to="/admin/products"><i class="fa fa-cubes fa-fw fa-lg text-orange"></i> Gestion des Articles</router-link>
                    <router-link class="btn btn-white m-r-5" to="/admin/clients"><i class="fa fa-users fa-fw fa-lg"></i> Gestion des Clients</router-link>
                    <router-link class="btn btn-white m-r-5" to="/admin/exports"><i class="fa fa-file-download fa-fw fa-lg"></i> Export des Données</router-link>
                </div>
            </div>

            <!--<h1 class="page-header">Playground  <small class="lead">.</small></h1>-->
            <hr class="bg-grey-lighter" />

            <div class="row m-b-5">
                <div class="col-md-12 m-b-0">
                    <router-link class="btn btn-white m-r-5" to="/admin/products"><i class="fa fa-cubes fa-fw fa-lg"></i></router-link>
                    <router-link class="btn btn-white m-r-5 text-orange" to="/admin/products/import"><i class="fa fa-download fa-fw fa-lg text-orange"></i> Importer</router-link>
                </div>
            </div>


            <div v-if="pageIndexApiData != null">
                <div class="row">
                    <div class="col-12">
                        <h2>Importer les articles<small></small></h2>
                        <div class="panel panel-default">
                            <div class="panel-heading">
                                <h4 class="panel-title">Chargez le fichier contenant la liste des articles</h4>
                            </div>
                            <div class="panel-body">
                                <div>
                                    <form class="form-horizontal form-bordered" @submit.prevent="uploadProductFileFormData">
                                        <div class="form-group row">
                                            <div class="col-xs-10">
                                                <input type="file" name="file" @change="fileSelected" ref="products_file" class="form-control" :disabled="pusherPayload.status == 'loading'">
                                                <div class="text-danger" v-if="productsFileUploadFormApiDataValidationErrors.file">
                                                    {{productsFileUploadFormApiDataValidationErrors.file[0]}}
                                                </div>
                                            </div>
                                            <div class="col-xs-2">
                                                <button :disabled="productsFileUploadFormApiDataIsLoading || productsFileUploadFormData.file === null || pusherPayload.status == 'loading'"
                                                        type="submit"
                                                        class="btn btn-success btn-block">
                                                    <i class="fas fa-spinner fa-spin" v-if="productsFileUploadFormApiDataIsLoading"></i>
                                                    <i class="fas fa-upload" v-else></i> Charger
                                                </button>
                                            </div>
                                        </div>
                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <div class="panel">
                            <div class="panel-body">
                                <div>
                                    <h2 v-if="pusherPayload.status == 'loading'"><i class="fas fa-spinner fa-pulse"></i> Chargement en cours ...</h2>
                                    <h2 v-else>Importation des données.</h2>
                                    <span v-if="productsFileUploadFormApiDataErrorMessage != null"><small class="lead text-danger">{{productsFileUploadFormApiDataErrorMessage}}</small><br/></span>
                                    <small class="lead"  :class="{'text-success':pusherPayload.status == 'success','text-warning':pusherPayload.status == 'warning','text-danger':pusherPayload.status == 'error',}" v-if="productsFileUploadFormApiDataErrorMessage == null && pusherPayload.message != ''">{{pusherPayload.message}}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-loader" v-else><span class="spinner-small"></span></div>
    </div>
</template>


<script>
    import pageApi from '../../store/api/admin/products-import-page-api'
    import LocalStorage from "../../store/local-storage";
    import CompanyLicenceComponent from '../../components/app/base/CompanyLicenceComponent.vue'

    export default {
        name: 'products-import-page-component',
        components: {
            CompanyLicenceComponent,
        },
        props: {},
        watch: {},
        computed: {},
        methods: {
            //Initialization Methods
            loadPageScripts() {
            },

            //Other Methods
            listenToServerBroadcastChannel() {
                let user = LocalStorage.getUserInfo();
                if (user.id != null && user.company_id != null) {
                    window.Echo.channel(window.appConfig.pusherBeamsChannelPrefix + '-products-upload-private-broadcast-channel-' + user.company_id + '-' + user.id)
                        .listen('ProductsUploadedPrivateEvent', (e) => {
                            this.pusherPayload = e.pusher_payload;
                        });
                }
            },

            fileSelected() {
                this.productsFileUploadFormData.file = this.$refs.products_file.files[0];
            },


            async getPageIndexApiData() {
                this.pageIndexApiDataIsLoading = true;
                this.pageIndexApiDataErrorMessage = null;
                try {
                    const response = await pageApi.getIndexData();
                    //console.log(response);
                    this.pageIndexApiData = response.data;
                    this.pageIndexApiDataIsLoading = false;
                    this.pageIndexApiDataErrorMessage = null;
                } catch (error) {
                    if (error.response) {
                        //Server responded with a status code that is NOT in the HTTP 200 range
                        //console.log("Headers", error.response.headers);
                        //console.log("Status Code", error.response.status);
                        //console.log("Response Data", error.response.data);
                        if (error.response.status === 401 || error.response.status === 403 || error.response.status === 419) {
                            this.pageIndexApiDataIsLoading = false;
                            this.pageIndexApiDataErrorMessage = error.response.data.message;
                            LocalStorage.clearSessionData();
                            this.$router.push('login');
                        }  else {
                            this.pageIndexApiDataIsLoading = false;
                            this.pageIndexApiDataErrorMessage = error.response.data.message;
                            //
                            this.$swal({
                                icon: 'error',//'info','success','warning','error','question',
                                toast: true,
                                position: 'bottom-end',
                                timer: 3000,
                                showConfirmButton: false,
                                title: 'HTTP ' + error.response.status,
                                text: error.response.data.message,
                            })
                        }
                    } else {
                        this.pageIndexApiDataIsLoading = false;
                        this.pageIndexApiDataErrorMessage = error.message;
                        //
                        this.$swal({
                            icon: 'error',//'info','success','warning','error','question',
                            toast: true,
                            position: 'bottom-end',
                            timer: 3000,
                            showConfirmButton: false,
                            //title: error.message
                            text: error.message,
                        })
                    }
                }
            },

            async uploadProductFileFormData() {
                this.productsFileUploadFormApiDataIsLoading = true;
                this.productsFileUploadFormApiDataErrorMessage = null;
                this.productsFileUploadFormApiDataValidationErrors = [];
                try {
                    const response = await pageApi.uploadProductFileFormData(this.productsFileUploadFormData);
                    //console.log(response);
                    this.productsFileUploadFormApiData = response.data;
                    this.productsFileUploadFormApiDataIsLoading = false;
                    this.productsFileUploadFormApiDataErrorMessage = null;
                    this.productsFileUploadFormApiDataValidationErrors = [];
                } catch (error) {
                    if (error.response) {
                        //Server responded with a status code that is NOT in the HTTP 200 range
                        //console.log("Headers", error.response.headers);
                        //console.log("Status Code", error.response.status);
                        //console.log("Response Data", error.response.data);
                        this.productsFileUploadFormApiDataIsLoading = false;
                        this.productsFileUploadFormApiDataErrorMessage = error.response.data.message;
                        if (error.response.status === 422) {
                            this.productsFileUploadFormApiDataValidationErrors =  error.response.data.errors;
                        }else {
                            this.productsFileUploadFormApiDataValidationErrors = [];
                        }
                    } else {
                        this.productsFileUploadFormApiDataIsLoading = false;
                        this.productsFileUploadFormApiDataErrorMessage = error.message;
                        this.productsFileUploadFormApiDataValidationErrors = [];
                    }
                }
            },
        },
        data: function () {
            return {
                appName: window.appConfig.appName,
                appCurrency: window.appConfig.appCurrency,
                intervalId01: 0,

                pusherPayload: {
                    status: '',
                    message: ''
                },

                //
                productsFileUploadFormData: {
                    file: null
                },

                //API Data
                //
                pageIndexApiData: null,
                pageIndexApiDataIsLoading: false,
                pageIndexApiDataErrorMessage: null,

                //
                productsFileUploadFormApiData: null,
                productsFileUploadFormApiDataIsLoading: false,
                productsFileUploadFormApiDataErrorMessage: null,
                productsFileUploadFormApiDataValidationErrors: [],
            };
        },
        created: function () {
            this.getPageIndexApiData();
        },
        mounted: function () {
            this.loadPageScripts();
            this.listenToServerBroadcastChannel();
        },
        beforeDestroy: function () {
        },
    }
</script>
